import { render, staticRenderFns } from "./SendAnnouncements.vue?vue&type=template&id=274bf43f&scoped=true"
import script from "./SendAnnouncements.vue?vue&type=script&lang=js"
export * from "./SendAnnouncements.vue?vue&type=script&lang=js"
import style0 from "./SendAnnouncements.vue?vue&type=style&index=0&id=274bf43f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274bf43f",
  null
  
)

export default component.exports